export default __webpack_public_path__ + "static/media/dateWhite.9bd2a96d.svg";